<template>
	<div class="content-container">
		<div class="content">
			<div class="container">
                <div class="row">

                    <!-- Title -->
                    <div class="col-12">
                        <div class="title">
                            <h1>Here are your repair options</h1>
                        </div>
                    </div>

                    <!-- Options -->
                    <div class="col-12">
                        <div class="card-list">

                            <!-- Doorstep service -->
                            <div class="selectable-card multiline-card"
                                 @click="setRepairLocationOption('doorstep')"
                                 :class="{'active': repairLocationOption === 'doorstep'}">
                                <div class="card-body">
                                    <h5>Doorstep service - we come to you!*</h5>
                                    <p class="text-sm">
                                        We'll repair your device in the Likewize Repair mobile workshop, at your home or work.
                                    </p>
                                </div>
                            </div>

                            <!-- In-store drop-off -->
                            <loading-state v-if="loading"></loading-state>
                            <div class="selectable-card multiline-card"
                                 v-if="!loading"
                                 @click="setRepairLocationOption('drop-off')"
                                 :class="{'active': repairLocationOption === 'drop-off'}">
                                <div class="card-body">
                                    <h5>In-store drop-off</h5>
                                    <p class="text-sm">
                                        Here are your three closest drop-off locations:
                                    </p>

                                    <ul class="drop-off-location-list">
                                        <li v-for="(store, index) in closestDropOffStores" :key="index">
                                            <div class="location-icon">
                                                <i class="fa fa-map-marker-alt"></i>
                                            </div>
                                            <div class="location-details">
                                                <h5 class="location-name">{{ store.address.town }}</h5>
                                                <p class="distance">
                                                    {{ store.distance }} Miles
                                                </p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <!-- Mail-in -->
        <!--                    <div class="selectable-card multiline-card"-->
        <!--                         @click="selectOption('mail-in')"-->
        <!--                         :class="{'active': selectedOption === 'mail-in'}">-->
        <!--                        <div class="card-body">-->
        <!--                            <h5>Mail-in</h5>-->
        <!--                            <p class="text-sm">-->
        <!--                                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod.-->
        <!--                            </p>-->
        <!--                        </div>-->
        <!--                    </div>-->

                        </div>
						<p class="text-sm">
							* Service available across the United Kingdom subject to postcode
						</p>
                    </div>

                </div>
                <!-- Footer -->
                <footer class="footer" :class="footerClass">
                    <div class="container">
                        <router-link :to="{ name: 'basket'}" class="btn btn-outline-secondary back-btn btn-lg"><i class="fa fa-chevron-left text-sm mr-3"></i> Back</router-link>
                        <router-link :to="{ name: nextStep() }" :disabled="!canProceedToNextStep" class="btn btn-primary btn-lg continue-btn icon-right ml-auto">Next <i class="fa fa-chevron-right ml-3 text-sm"></i></router-link>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: 'RepairOptions',

        data() {
            return {
                loading: true,
                closestDropOffStores: []
            }
        },

        mounted() {
            // this.checkCanBeOnPage();

            // Revert Customers Postcode if they have chosen to drop off but then changed their mind
            if(this.customerPostcode) {
                const postcode = this.customerPostcode;
                const requestParams = {model_version_id: null, problems: null};

                this.setBookingPostcode({postcode, requestParams}).then(() => {
                    this.removeDropOffCompanyStoreId().then(() => {
                        this.setCustomerPostcodeCache(null).then(() => {
                            this.getClosestDropOffEnabledStores({
                                postcode: this.customerPostcodeCacheOrBookingPostcode,
                                carrier: this.carrier
                            }).then(response => {
                                this.loading = false;
                                this.closestDropOffStores = response.data
                            });
                        })
                    });
                });
            } else {
                this.getClosestDropOffEnabledStores({
                    postcode: this.customerPostcodeCacheOrBookingPostcode,
                    carrier: this.carrier
                }).then(response => {
                    this.loading = false;
                    this.closestDropOffStores = response.data
                });
            }
        },

        computed: {
            ...mapGetters([
                'hasDevices',
                'repairLocationOption',
                'carrier',
                'bookingPostcode',
                'customerPostcode',
                'isBookingInStore'
            ]),

            canProceedToNextStep() {
                return !this.repairLocationOption || !this.loading;
            },

            customerPostcodeCacheOrBookingPostcode() {
                return (this.customerPostcode) ? this.customerPostcode : this.bookingPostcode
            },

            pageTitle() {
                if (this.isBookingInStore) {
                    return "Here are the repair options";
                }

                return "Here are your repair options";
            },

            footerClass() {
                return (window.innerHeight < 768) ? "fixed-footer" : "";
            }
        },

        methods: {
            ...mapActions([
                'checkBookingIsComplete',
                'setRepairLocationOption',
                'getClosestDropOffEnabledStores',
                'setCustomerPostcodeCache',
                'setBookingPostcode',
                'setDropOffCompanyStoreId',
                'removeDropOffCompanyStoreId'
            ]),

            checkCanBeOnPage() {
                this.checkBookingIsComplete().then(() => {
                    if (!this.hasDevices) {
                        this.$router.push({name: 'basket'});
                    }
                });
            },


            nextStep() {
                if(this.repairLocationOption === 'drop-off') {
                    return 'dropOffLocationSelect';
                }
                return 'repairDates';
            },
        }
    }
</script>

<style scoped>

</style>